import React, { Component } from 'react';

export default class view extends Component {
	render() {
		var PAList = []
		for (var pa of this.props.data.PAList) {
			console.log(pa)
			PAList.push(<p>PA Number {pa.PA_Number}, Billing Code {pa.NDC_Code.slice(4, 11)} for {pa.Refills_Requested} refills for {pa.Cals_Req}  calories per day and   {(pa.Cals_Req / 100) * 30}  caloric units per month was completed by you on {new Date(pa.Pharmacy_Date).toLocaleDateString()}.  The earliest that this formula can be reauthorized is:  {new Date((new Date(pa.Expiration_Date) - (86400000 * 10))).toLocaleDateString()} </p>)
		}

		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>You have completed the following authorizations for this member:</p>
				{PAList}
				<div className="button" onClick={() => this.props.navigate('F4')}>Continue</div>
			</div>
		);
	}
}
//